import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Collapse,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Button
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Assessment as AssessmentIcon,
  ExpandLess,
  ExpandMore,
  Close as CloseIcon,
  Book as BookIcon,
  School as SchoolIcon,
  } from "@mui/icons-material";

const drawerWidth = 240;

const Sidebar = ({ open, onClose, role }) => {
  console.log('sidebar: ' + role)
  const [editBooksOpen, setEditBooksOpen] = useState(false);
  const [editEventsOpen, setEventsOpen] = useState(false);
  const [editBlogsOpen, setEditBlogsOpen] = useState(false);
  const [editCoursesOpen, setEditCoursesOpen] = useState(false);
  const [editTestimonialsOpen, setEditTestimonialsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const drawerContent = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          minHeight: { xs: 56, sm: 64 },
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography variant="h6" color="textSecondary">
          Navigation
        </Typography>
        {isMobile && (
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      {role === 'admin' ? (
        <List sx={{ p: 2 }}>
          {/* <Button  sx={{backgroundColor: 'blue', color: 'white', padding: 1, width: '170px', margin: 2}}>CRM</Button> */}
          <Button onClick={() => {
            navigate('/crm')
          }}
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: '#1976d2', // Green color for the button
              borderRadius: '5px', // Rounded edges
              padding: '10px 20px', // Padding inside the button
              textTransform: 'none', // Avoid text transformation
              fontWeight: 'bold',
              fontSize: '16px',
              '&:hover': {
                backgroundColor: 'blue', // Darker green when hovered
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow effect
              margin: 2,
              width: '160px',
            }}
          >
            CRM
          </Button>
          <ListItemButton
            sx={{ mb: 1, borderRadius: 1 }}
            onClick={() => navigate("/admin-dashboard")}
          >
            <ListItemIcon>
              <DashboardIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>

          <ListItemButton
            sx={{ mb: 1, borderRadius: 1 }}
            onClick={() => navigate("/admin-dashboard/create-courses")}
          >
            <ListItemIcon>
              <PeopleIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Create Courses" />
          </ListItemButton>

          <ListItemButton
            onClick={() => setEditBooksOpen(!editBooksOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <BookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Edit Books" />
            {editBooksOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={editBooksOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Add Books", path: "/admin-dashboard/edit-books/add-books" },
                { text: "Update/Delete Books", path: "/admin-dashboard/edit-books/update-books" },
                { text: "Change Order", path: "/admin-dashboard/edit-courses/carousel-cards" },
                { text: "Enquiries", path: "/admin-dashboard/enquiries" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton
            onClick={() => setEditBlogsOpen(!editBlogsOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <BookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Manage Blogs" />
            {editBlogsOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>


          <Collapse in={editBlogsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Add Blogs", path: "/admin-dashboard/manage-blogs/add-blogs" },
                { text: "Add News", path: "/admin-dashboard/manage-blogs/add-news" },
                { text: "Update/Delete Blogs", path: "/admin-dashboard/manage-blogs/update-blogs" },
                { text: "Update/Delete News", path: "/admin-dashboard/manage-blogs/update-news" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton
            sx={{ mb: 1, borderRadius: 1 }}
            onClick={() => navigate("/admin-dashboard/edit-schools")}
          >
            <ListItemIcon>
              <SchoolIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Edit Schools" />
          </ListItemButton>

          <ListItemButton
            onClick={() => setEventsOpen(!editEventsOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <BookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Edit Events" />
            {editBooksOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={editEventsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Add Events", path: "/admin-dashboard/edit-events" },
                { text: "Update/Delete Events", path: "/admin-dashboard/update-events" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton
            onClick={() => setEditCoursesOpen(!editCoursesOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <AssessmentIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Edit Courses" />
            {editCoursesOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={editCoursesOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Carousel View", path: "/admin-dashboard/edit-courses/carousel-cards" },
                { text: "Color Cards", path: "/admin-dashboard/edit-courses/color-cards" },
                { text: "Course Cards", path: "/admin-dashboard/edit-courses/course-cards" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItemButton
            onClick={() => setEditTestimonialsOpen(!editTestimonialsOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <BookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Edit Testimonials" />
            {editTestimonialsOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={editTestimonialsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Add Testimonials", path: "/admin-dashboard/edit-testimonials/add-testimonials" },
                { text: "Update/Delete Testimonials", path: "/admin-dashboard/edit-testimonials/update-testimonials" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

        </List>) :
        <List sx={{ p: 2 }}>
          <ListItemButton
            sx={{ mb: 1, borderRadius: 1 }}
            onClick={() => navigate("/user-dashboard")}
          >
            <ListItemIcon>
              <DashboardIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>

          <ListItemButton
            onClick={() => setEditBlogsOpen(!editBlogsOpen)}
            sx={{ mb: 1, borderRadius: 1 }}
          >
            <ListItemIcon>
              <BookIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Manage Blogs" />
            {editBlogsOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={editBlogsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {[
                { text: "Add Blogs", path: "/user-dashboard/manage-blogs/add-blogs" },
                { text: "Update/Delete Blogs", path: "/user-dashboard/manage-blogs/update-blogs" },
              ].map((item) => (
                <ListItemButton
                  key={item.text}
                  sx={{ pl: 4, py: 1, borderRadius: 1 }}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </List>

      }
    </>
  );

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          border: "none",
          borderRight: "2px solid rgba(0, 0, 0, 0.12)",
          ...(!isMobile &&
            !open && {
            width: 0,
            visibility: "hidden",
          }),
        },
        width: !isMobile && open ? drawerWidth : 0,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export default Sidebar;

